import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toastr } from 'react-redux-toastr';
import * as recipientAccountActions from '../../../redux/actions/RecipientAccountsActions';
import * as applicationActions from '../../../redux/actions/ApplicationsActions';
import * as checkPrintingActions from '../../../redux/actions/CheckPrintingActions';
import { getSystemSettings } from '../../../redux/actions/SettingsActions';
import { getBlankChecks } from '../../../redux/actions/FundsActions';
import { PermissionTypes, RecipientTypes } from '../../../lib/systemVariables';
import queryString from 'query-string';

import RecipientAccountNavigationHeader from './RecipientAccountNavigationHeader';
import RecipientAccountDetails from './RecipientAccountDetails';
import RecipientAccountCampaignsTable from './RecipientAccountCampaignsTable';
import RecipientAccountApplications from './RecipientAccountApplications';

class RecipientAccountDetailsPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentRecipientId: this.props.match.params.id,
            currentApplicationId: parseInt(queryString.parse(props.history.location.search).applicationId) || null,
            prevPage: props.location.state ? props.location.state.prevPage : '',
            recipientEditMode: false,
            applicationEditMode: false
        };
    }

    componentWillMount() {
        this.getAccountDetails(this.state.currentRecipientId, this.state.currentApplicationId);
    }

    async getAccountDetails(recipientId, applicationId) {
        this.getRecipientDetails(recipientId);
        this.getRecipientApplicationHistory(recipientId, applicationId);

        if (this.state.currentRecipientId !== recipientId) {
            this.props.history.replace({ pathname: `/recipient-accounts/${recipientId}` });
            this.setState({ currentRecipientId: recipientId });
        }

        if (applicationId && this.state.currentApplicationId !== applicationId) {
            this.props.history.replace({ search: `?applicationId=${applicationId}` });
            this.setState({ currentApplicationId: applicationId });
        }
    }

    async getRecipientDetails(recipientId, reload) {
        await this.props.actions.getRecipientAccountDetails(recipientId, reload);

        if (!this.props.recipientDetails.success) {
            toastr.error('Something went wrong', 'We were unable to retrieve recipient details. Please try again');
        }
    }

    async getRecipientApplicationHistory(recipientId, applicationId) {
        await this.props.actions.getRecipientApplicationHistory(recipientId);

        if (this.props.applicationHistory.success) {
            const appHistory = this.props.applicationHistory.data;
            this.selectApplication(applicationId || (appHistory.length ? appHistory[0].applicationId : null), recipientId);
        } else {
            toastr.error('Something went wrong', `We were unable to retrieve the application history for this recipient.  Please try again.`);
        }
    }

    async selectApplication(applicationId, recipientId) {
        if (applicationId) {
            await this.getApplicationDetails(applicationId, false, recipientId);
        }
        else 
        {
            this.props.history.replace({ search: '' });
            this.setState({ currentApplicationId: null });
        }
    }

    async getApplicationDetails(applicationId, updateHistory, recipientId) {
        if (applicationId) {
            if (applicationId && this.state.currentApplicationId !== applicationId) {
                this.props.history.replace({ search: `?applicationId=${applicationId}` });
                this.setState({ currentApplicationId: applicationId });
            }

            await this.props.actions.getApplicationDetails(applicationId, updateHistory, recipientId);
            if (!this.props.applicationDetails.success)
                toastr.error('Something went wrong', `We were unable to retrieve application details.  Please try again.`);
        }
    }

    getRecipientApplicationsForExport = async (props) => {
        await this.props.actions.getRecipientApplicationsForExport(props.fields, props.recipientId, props.startDate, props.endDate);
    }

    toggleEditMode = editMode => this.setState({ [editMode]: !this.state[editMode] });

    render() {
        const recipientDetails = this.props.recipientDetails.data;

        return (
            <div className="page">
                <RecipientAccountNavigationHeader
                    history={this.props.history}
                    prevPage={this.state.prevPage}
                    campaignId={this.props.location.state ? this.props.location.state.campaignId : null}
                    campaignListId={this.props.location.state ? this.props.location.state.campaignListId : null}
                    applicationId={this.props.location.state ? this.props.location.state.applicationId : null}
                    recipientId={this.state.currentRecipientId}
                    getApplicationsToRecipientIdsMapping={this.props.actions.getApplicationsToRecipientIdsMapping}
                    applicationsToRecipientIdsMapping={this.props.applications.applicationsToRecipientIdsMapping}
                    getAccountDetails={this.getAccountDetails.bind(this)} />

                <div className="container">
                    {this.props.permissions.recipients.view &&
                        <RecipientAccountDetails
                            editMode={this.state.recipientEditMode}
                            toggleEditMode={() => this.toggleEditMode("recipientEditMode")}
                            disableEditMode={this.state.applicationEditMode || this.props.applicationHistory.loading || !this.props.applicationHistory.success}

                            recipientDetails={this.props.recipientDetails}
                            applicationHistory={this.props.applicationHistory.data}
                            updateRecipient={this.props.actions.updateRecipientDetails}
                            updateRecipientDetails={this.props.updateRecipientDetails}
                            getRecipientDetails={this.getRecipientDetails.bind(this)}
                            getApplicationHistory={this.getRecipientApplicationHistory.bind(this, this.state.currentRecipientId, this.state.currentApplicationId)}

                            addNote={this.props.actions.addRecipientNote}
                            updateNote={this.props.actions.updateRecipientNote}
                            deleteNote={this.props.actions.deleteRecipientNote}
                            updatingNote={this.props.recipientNotesUpdate}

                            userId={this.props.userId}
                            permissions={this.props.permissions.recipients}
                            isAdmin = {this.props.permissions.admin}
                            isApprover = {this.props.permissions.approver}
                            tags={{
                                usPersonTitles: this.props.systemSettings.recipientSettings.usPersonTitles,
                                israelPersonTitles: this.props.systemSettings.recipientSettings.israelPersonTitles,
                                usInstitutionTitles: this.props.systemSettings.recipientSettings.usInstitutionTitles,
                                israelInstitutionTitles: this.props.systemSettings.recipientSettings.israelInstitutionTitles,
                                recipientTypes: this.props.systemSettings.otherSettings.recipientTypes,
                                categories: {
                                    individualTags: this.props.systemSettings.recipientSettings.individualTags,
                                    organizationTags: this.props.systemSettings.recipientSettings.organizationTags
                                },
                                nationalities: this.props.systemSettings.otherSettings.nationalities,
                                cities: this.props.systemSettings.otherSettings.cities,
                                orgEmploymentTypes: this.props.systemSettings.otherSettings.orgEmploymentTypes
                            }}
                            getSystemSettings={this.props.actions.getSystemSettings}
                        />}

                    {(this.props.permissions.campaigns.view && (recipientDetails.applicantType === 'Organization'
                        && (recipientDetails.campaignListId || (recipientDetails.campaigns && recipientDetails.campaigns.length > 0)))) &&
                        <RecipientAccountCampaignsTable
                            campaigns={recipientDetails.campaigns}
                            campaignListId={recipientDetails.campaignListId} />}

                    {(this.props.permissions.applications.view && recipientDetails.applicantId) &&
                        <RecipientAccountApplications
                            editMode={this.state.applicationEditMode}
                            toggleEditMode={() => this.toggleEditMode("applicationEditMode")}
                            disableEditMode={this.state.recipientEditMode}

                            recipientDetails={recipientDetails}
                            applicationHistory={this.props.applicationHistory}
                            currentApplicationId={this.state.currentApplicationId}
                            currentApplicationDetails={this.props.applicationDetails}
                            selectApplication={this.selectApplication.bind(this)}
                            getApplicationDetails={this.getApplicationDetails.bind(this)}

                            updateApplicationStatus={this.props.actions.updateApplicationsStatus}
                            revertApplicationStatus={this.props.actions.revertApplicationStatus}
                            applicationStatusUpdate={this.props.applications.updating}
                            printCheck={this.props.actions.printChecks}
                            printing={this.props.checkPrinting.printing}
                            confirmPrinting={this.props.actions.confirmChecksPrinted}
                            confirmingPrinting={this.props.checkPrinting.confirmPrinting}
                            wireApplication={this.props.actions.wireApplications}
                            sendACH={this.props.actions.sendACHApplications}
                            sendingACH={this.props.applications.sendingACH}
                            voidPayment={this.props.actions.voidApplicationPayment}
                            voidingPayment={this.props.applications.voidingPayment}
                            addNote={this.props.actions.addApplicationNote}
                            updateNote={this.props.actions.updateApplicationNote}
                            deleteNote={this.props.actions.deleteApplicationNote}
                            updatingNote={this.props.applicationNotesUpdate}                                
                            updateAttachments={this.props.actions.updateApplicationAttachments}
                            updatingAttachments={this.props.applicationAttachmentsUpdate}
                            updateReceipts={this.props.actions.updateApplicationReceipts}
                            deleteReceipt={this.props.actions.deleteApplicationReceipt}
                            updatingReceipts={this.props.applicationReceiptsUpdate}

                            userId={this.props.userId}
                            permissions={this.props.permissions}

                            funds={this.props.funds}

                            getBlankChecks={this.props.actions.getBlankChecks}
                            blankChecks={this.props.blankChecks}
                            manualPaymentTypes={this.props.systemSettings.otherSettings.manualPaymentTypes}

                            updateApplication={this.props.actions.updateApplicationDetails}
                            updateApplicationDetails={this.props.updateApplicationDetails}
                            getApplicationHistory={this.getRecipientApplicationHistory.bind(this, this.state.currentRecipientId, this.state.currentApplicationId)}

                            getRecipientApplicationsForExport={this.getRecipientApplicationsForExport.bind(this)}
                            export={this.props.export}

                            tags={{
                                applicationReasons: recipientDetails.applicantType === RecipientTypes.Organization
                                    ? this.props.systemSettings.applicationSettings.organizationApplicationReasons : this.props.systemSettings.applicationSettings.individualApplicationReasons,
                                approvers: this.props.tags.approvers,
                                cardTypes: this.props.systemSettings.printSettings.cardTypes,
                                references: this.props.tags.references,
                                recipientTypes: this.props.systemSettings.otherSettings.recipientTypes,
                                usFunds: this.props.tags.funds.US,
                                israeliFunds: this.props.tags.funds.IL,
                                defaultUSFund: this.props.tags.defaultUSFund,
                                defaultIsraelFund: this.props.tags.defaultIsraelFund,
                                campaignIndivCategories: this.props.systemSettings.campaignSettings.campaignIndivCategories
                            }} />}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        ...state.recipientAccountDetails,
        applications: state.applications,
        checkPrinting: state.checkPrinting,
        userId: state.userProfile.profile.data.userId,
        permissions: {
            recipients: {
                view: state.userProfile.permissions.data.indexOf(PermissionTypes.RecipientAccntsView) >= 0,
                manage: state.userProfile.permissions.data.indexOf(PermissionTypes.RecipientAccntsManage) >= 0
            },
            campaigns: {
                view: state.userProfile.permissions.data.indexOf(PermissionTypes.CampaignAndListsView) >= 0
            },
            applications: {
                view: state.userProfile.permissions.data.indexOf(PermissionTypes.ApplicationsView) >= 0,
                manage: state.userProfile.permissions.data.indexOf(PermissionTypes.ApplicationsManage) >= 0,
                approveFull: state.userProfile.permissions.data.indexOf(PermissionTypes.ApplicationsApproveFull) >= 0,
                approveLimited: state.userProfile.permissions.data.indexOf(PermissionTypes.ApplicationsApproveLimited) >= 0,
                wire: state.userProfile.permissions.data.indexOf(PermissionTypes.PaymentsWire) >= 0,
                print: state.userProfile.permissions.data.indexOf(PermissionTypes.PaymentsPrint) >= 0,
                void: state.userProfile.permissions.data.indexOf(PermissionTypes.PaymentsVoid) >= 0,
                private: state.userProfile.permissions.data.indexOf(PermissionTypes.ApplicationsPrivate) >= 0
            },
            accounting: {
                manage: state.userProfile.permissions.data.indexOf(PermissionTypes.AccountingManage) >= 0
            },
            admin: state.userProfile.profile.data.roleId === 1,
            approver: state.userProfile.profile.data.roleId === 3
        },
        blankChecks: state.fundDetails.blankChecks,
        systemSettings: state.settings.systemSettings.data,
        tags: {
            campaigns: state.campaigns.campaigns.data,
            organizations: state.recipientAccounts.organizations.data,
            approvers: state.users.approvers.data,
            references: state.references.references.data,
            funds: state.funds.fundsByDept,
            defaultUSFund: state.settings.systemSettings.data.fundSettings.defaultUSFund,
            defaultIsraelFund: state.settings.systemSettings.data.fundSettings.defaultIsraelFund,
        },
        userProfile: state.userProfile,
        funds: state.funds.fundsByDept.allWithLimits
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...recipientAccountActions, ...applicationActions, ...checkPrintingActions, getBlankChecks, getSystemSettings }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RecipientAccountDetailsPage);




// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccountDetails/RecipientAccountDetailsPage.jsx